<template>
  <div>
    <PageHeading class="stk-mb-6">
      <template #title>
        Action Center
      </template>
      <template #subtitle>
        Find all tasks and recommendations manually created or generated by the meeting notetaker feature.
      </template>
    </PageHeading>

    <Pills id="entity-navigation-links">
      <PillsList>
        <PillItem
          v-for="link in navigationLinks"
          :key="link.to.name"
          :to="link.to"
          :icon="link.icon"
          replace
        >
          {{ link.label }}
        </PillItem>
      </PillsList>
    </Pills>

    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { PageHeading, Pills, PillsList, PillItem } from '@stakeui';

const navigationLinks = computed(() => {
  const items = [
    {
      label: 'Inbox',
      icon: 'fas fa-inbox',
      to: { name: 'action-center-inbox' },
    },
    {
      label: 'Active Tasks',
      icon: 'fas fa-tasks',
      to: { name: 'action-center-tasks' },
    },
    {
      label: 'Snoozed',
      icon: 'fas fa-hourglass-half',
      to: { name: 'action-center-snoozed' },
    },
    {
      label: 'Dismissed',
      icon: 'fas fa-ban',
      to: { name: 'action-center-dismissed' },
    },
    {
      label: 'Completed',
      icon: 'fas fa-check',
      to: { name: 'action-center-completed' },
    },
  ];

  return items.sort((a, b) => a.position - b.position); ;
});
</script>
